export const primaryColor = '#211747';
export const accentColor = '#02a5a9';

export const tabItems = [
  { value: 'results', label: 'Results' },
  { value: 'history', label: 'History' },
  { value: 'analyticsDrift', label: 'Analytics Drift' },
  { value: 'drift', label: 'Screen Drift' },
  { value: 'healing', label: 'Healing History' },
  { value: 'versionDiff', label: 'Version Diff' },
];

export const driftCategories = [
  {
    key: 'REGRESSION',
    label: 'Regressions',
    color: 'error',
    defaultOpen: true,
  },
  { key: 'REMOVED', label: 'Removed', color: 'warning', defaultOpen: true },
  { key: 'NEW', label: 'New', color: 'info' },
  { key: 'ADDED', label: 'Added', color: 'info' },
  { key: 'FIXED', label: 'Fixed', color: 'success' },
  { key: 'PASSED', label: 'Stable', color: 'default' },
  { key: 'STABLE', label: 'Stable', color: 'default' },
  { key: 'FAILED_BOTH', label: 'Failed Both', color: 'default' },
];

export const analyticsCategories = [
  {
    key: 'REGRESSION',
    label: 'Regressions',
    color: 'error',
    defaultOpen: true,
  },
  { key: 'FAILED_BOTH', label: 'Failed Both', color: 'default' },
  { key: 'REMOVED', label: 'Removed', color: 'warning' },
  { key: 'NEW', label: 'New', color: 'info' },
  { key: 'FIXED', label: 'Fixed', color: 'success' },
  { key: 'PASSED', label: 'Passed', color: 'success' },
];
